import { render, staticRenderFns } from "./SwimCourseSummary.vue?vue&type=template&id=2a892aeb&scoped=true&"
import script from "./SwimCourseSummary.vue?vue&type=script&lang=js&"
export * from "./SwimCourseSummary.vue?vue&type=script&lang=js&"
import style0 from "./SwimCourseSummary.vue?vue&type=style&index=0&id=2a892aeb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a892aeb",
  null
  
)

component.options.__file = "SwimCourseSummary.vue"
export default component.exports